import loader from './lib/Loader';

import(/* webpackPrefetch: true */ './icons');
loader('slider', '.slider');
loader('navbar', '.header');
loader('dropdown', '.dropdown');
loader('infoblocks', '.info-block--hover');
loader('lang-switch', '.language-switch');
loader('kennistabs', '.kennisdeling__tabs');
loader('faq', '.faq');
loader('filter', '.filter-single');
loader('filter-selections', '.filter-selections');
loader('filters', '.filters');
loader('search-hero', '.search-hero');
loader('tabs', '.content-tabs');
loader('anchor', 'a:not(.skiplink)');
loader('forms', '');
loader('single-tags', '.single-content__sidebar');
loader('kennisbanken-hero', '.kennisbanken-hero');
loader('vacatures-hero', '.vacatures-archive-hero');
loader('form-upload-file', '.single-vacature__apply');
loader('footer', 'footer');
loader('contact', '.contact');
loader('filename', '.upload');